<template>
  <div :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="12">
          <a-col :md="6" :sm="8">
            <a-form-item label="Account Name">
              <a-input  v-model="queryParam.mobileNo"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item label="Transaction Type">
              <a-select default-value="" style="width: 120px" v-model="queryParam.flowType">
                <a-select-option :value="0">
                  Withdrawal
                </a-select-option>
                <a-select-option :value="1">
                  Income
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>


          <a-col :md="6" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('search') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('reset') }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>

      <a-table
        ref="table"
        rowKey="id"
        size="middle"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"
        bordered>
      </a-table>
      <div style="margin-top: 15px; text-align: right;">
        <v-pagination
          v-if="total"
          :page-num="form.pageNum"
          :page-size="form.pageSize"
          :total="total"
          @change="handleTableChange" />
      </div>
    </div>
  </div>
</template>

<script>
import { filterObj } from '@/utils/util'
import {collectionAccountTradeFlowList} from "@/webpublicapi/CollectionAccountInfo";

const I18N_KEY = {
  ORDER: 'order.',
  CUSTOMER: 'customer.',
  COLLECTION: 'collection.'
}

export default {
  name: 'AllApprovalTask',
  data () {
    return {
      I18N_KEY,
      // Pagination params
      form: {
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
      dataSource: [],
      // Query conditions
      queryParam: {
        mobileNo:"",
        flowType: 1
      },
      loading: false
    }
  },
  computed: {
    columns () {
      return [
        {
          title: "Bank CardNo.",
          align: 'left',
          dataIndex: 'bankCardNo'
        },
        {
          title:  "Transaction Status",
          align: 'left',
          dataIndex: 'tradeStatus',
          customRender: (text) => {
            // 00-In transaction 01-Transaction success 02-Transaction refund 03-Transaction cancelled 04-Transaction failed 05-In transaction queue
            if ("00" === text) {
              return "Transaction in ";
            } else if ("01" === text) {
              return "Transaction Success";
            } else if ("02" === text) {
              return "Transaction Refund";
            } else if ("04" === text) {
              return "Transaction Failed";
            }
            return text;
          }
        },
        {
          title: 'Amount',
          align: 'left',
          dataIndex: 'tradeAmount'
        },
        {
          title:'Created Time',
          align: 'left',
          dataIndex: 'createdTime'
        },
        {
          title: 'Withdrawal Time',
          align: 'left',
          dataIndex: 'tradeTime'
        }
      ]
    },
  },
  created () {
  },
  methods: {
    searchQuery () {
      this.loadData(1)
    },
    loadData (arg) {
      // Load data If params passed1Then load first page content
      if (arg === 1) {
        this.form.pageNum = 1
      }
      this.loading = true
      var params = this.getQueryParams()// Query conditions
      collectionAccountTradeFlowList(Object.assign({}, params)).then((res)=>{
        if(res.code===1000){
          this.total = res.data.total
          this.dataSource = res.data.rows
        }else{
          this.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false;
        this.$message.error(e.message);
      })
    },

    getQueryParams () {
      const data = {
        ...this.queryParam
      }
      delete data.endTime;
      var param = Object.assign({}, data)
      param.pageNum = this.form.pageNum;
      param.pageSize = this.form.pageSize;
      return filterObj(param)
    },
    handleTableChange (pageNum, pageSize) {
      this.form.pageNum = pageNum;
      this.form.pageSize = pageSize;
      this.loadData();
    },
    // Reset dictionary type search box content
    searchReset () {
      var that = this
      that.queryParam.mobileNo = ''
      that.queryParam.flowType = 1
      that.loadData(this.form.pageNum)
    }
  }
}
</script>
<style lang="less" scoped>
@import "~@/assets/less/common.less";
.description {
  line-height: 1.4;
  &.d_text {
    text-indent: 1em;
  }
  &.d_high_light {
    color: #fd9a38;
  }
}
</style>
